class ProductGallery extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.panels = [...this.querySelectorAll('[data-product-media-panel]')];
    this.thumbnails = [...this.querySelectorAll('[data-product-media-thumbnail]')];
    this.status = this.querySelector('[data-product-media-status]');
    this.previousButton = this.querySelector('[data-product-media-previous]');
    this.nextButton = this.querySelector('[data-product-media-next]');
    this.index = Math.max(0, this.panels.findIndex((panel) => panel.classList.contains('is-active')));
    if (!this.panels.length) return;

    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => this.show(index, true));
      thumbnail.addEventListener('keydown', (event) => this.onThumbnailKeydown(event, index));
    });
    this.previousButton?.addEventListener('click', () => this.show(this.index - 1, true));
    this.nextButton?.addEventListener('click', () => this.show(this.index + 1, true));
    this.classList.add('is-ready');
    this.show(this.index, false);
  }

  show(index, announce = false) {
    this.index = (index + this.panels.length) % this.panels.length;
    this.panels.forEach((panel, panelIndex) => {
      const active = panelIndex === this.index;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
      if (!active) panel.querySelectorAll('video').forEach((video) => video.pause());
    });
    this.thumbnails.forEach((thumbnail, thumbnailIndex) => {
      const active = thumbnailIndex === this.index;
      thumbnail.classList.toggle('is-active', active);
      thumbnail.setAttribute('aria-selected', String(active));
      thumbnail.tabIndex = active ? 0 : -1;
    });
    this.thumbnails[this.index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    if (announce && this.status) this.status.textContent = `Showing media ${this.index + 1} of ${this.panels.length}`;
  }

  onThumbnailKeydown(event, index) {
    let nextIndex = null;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = index + 1;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = index - 1;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.panels.length - 1;
    if (nextIndex === null) return;
    event.preventDefault();
    this.show(nextIndex, true);
    this.thumbnails[this.index]?.focus();
  }
}

if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
